import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Student } from '../student';
import { StudentService } from '../services/student.service';
import { StudentDialogComponent, StudentDialogData } from './student-dialog/student-dialog.component';

@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrls: ['./students.component.css']
})
export class StudentsComponent implements OnInit {

  students = new MatTableDataSource<Student>([]);
  displayedColumns: string[] = ['name', 'email', 'mobileNumber', 'rollNumber', 'className', 'actions'];

  constructor(
    private studentService: StudentService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.students.filterPredicate = (data: Student, filter: string) => {
      const f = filter.trim().toLowerCase();
      if (!f) {
        return true;
      }
      const parts = [
        data.firstName,
        data.lastName,
        data.rollNumber,
        data.className,
        data.email,
        data.mobileNumber != null ? String(data.mobileNumber) : ''
      ];
      return parts.some(p => (p || '').toLowerCase().includes(f));
    };
    this.loadStudents();
  }

  loadStudents(): void {
    this.studentService.getAll().subscribe(
      data => {
        this.students.data = data || [];
      },
      () => {
        this.students.data = [];
        this.snackBar.open('Could not load students.', 'Dismiss', { duration: 4000 });
      }
    );
  }

  openCreateStudent(): void {
    const data: StudentDialogData = { mode: 'create' };
    this.dialog.open(StudentDialogComponent, {
      width: '680px',
      maxHeight: '90vh',
      data
    }).afterClosed().subscribe(saved => {
      if (saved) {
        this.loadStudents();
      }
    });
  }

  /** Row click: full-page student profile (openSIS-style). */
  openStudentDetails(row: Student): void {
    if (row.id != null) {
      this.router.navigate(['/home/students', row.id]);
      return;
    }
    this.snackBar.open('Student must be saved on the server to open the full profile.', 'Dismiss', { duration: 5000 });
  }

  /** Pencil: edit (dialog submit uses PUT /students/:id). */
  openEditStudent(event: MouseEvent, row: Student): void {
    event.stopPropagation();
    const data: StudentDialogData = { mode: 'edit', student: { ...row } };
    this.dialog.open(StudentDialogComponent, {
      width: '680px',
      maxHeight: '90vh',
      data
    }).afterClosed().subscribe(saved => {
      if (saved) {
        this.loadStudents();
      }
    });
  }

  deleteStudent(event: MouseEvent, row: Student): void {
    event.stopPropagation();
    const id = row.id;
    if (id == null) {
      return;
    }
    const label = [row.firstName, row.lastName].filter(Boolean).join(' ').trim() || 'this student';
    if (!window.confirm(`Delete ${label}? This cannot be undone.`)) {
      return;
    }
    this.studentService.delete(id).subscribe(
      () => {
        this.snackBar.open('Student deleted', 'Dismiss', { duration: 3000 });
        this.loadStudents();
      },
      () => {
        this.snackBar.open('Could not delete student.', 'Dismiss', { duration: 5000 });
      }
    );
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.students.filter = filterValue.trim().toLowerCase();
  }
}
